import { COTTypes } from 'data/ScreensData/screenData';
import { FactsScreenToastMessages } from 'data/toastMessages/facts';
import { useStore } from 'hooks/useStore';
import { futureTmsDeactivatationRequestPayload } from 'Interfaces/FactsInterfaces/tmsInterfaces';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { factScreenServices } from 'services/factsScreenServices';

const cotOptions = () => {
  const options: { name: string; code: string }[] = [];
  COTTypes.forEach(type => {
    options.push({ name: type, code: type });
  });
  return options;
};

export const useMarketStrategyHistoryModal = () => {
  const {
    FactsStore: {
      isMarketHisotryVisible,
      isDirectStrategyEditOpen,
      handleFetchTargetMarketShareForSelectedGFC,
      toggleMarketHitoryVisibility,
      handleFetchMarketHitoricalData,
      handleFetchMarketHitoricalDataForCot,
      isMarketHistoryLoading,
      marketStrategyHistoricalData,
    },
  } = useStore();
  const [allOptions] = useState(cotOptions());
  const [selectedCOT, setSelectedCOT] = useState(allOptions[0]);
  const dropdownRef = useRef<HTMLInputElement>(null);
  const hiddenInputElementRef = useRef<HTMLInputElement>(null);
  const [deletingIndexes, setDeletingIndexes] = useState<Set<number>>(new Set());
  const columnDetails = [
    {
      key: 'tms',
      label: 'TMS (%)',
    },
    {
      key: 'strategy',
      label: 'Strategy',
    },
    {
      key: 'startDate',
      label: 'Start Date',
    },
    {
      key: 'endDate',
      label: 'End Date',
    },
  ];

  const handleStrategyChange = async (cotName: string) => {
    if (cotName)
      await handleFetchMarketHitoricalDataForCot(
        selectedCOT.name,
        isDirectStrategyEditOpen ? 'Direct' : 'Indirect'
      );

    if (dropdownRef) dropdownRef.current?.focus();
  };

  const handleDeleteFutureTms = async (marketShareId: number) => {
    try {
      const tempDeletingIndexes = [...deletingIndexes];
      const tmepIndexes = new Set<number>([...tempDeletingIndexes]);
      tmepIndexes.add(marketShareId);
      setDeletingIndexes(tmepIndexes);
      const payload: futureTmsDeactivatationRequestPayload = {
        MarketShareID: marketShareId,
      };
      await factScreenServices.deactivateFutureTms(payload);
      await handleFetchTargetMarketShareForSelectedGFC();
      toast.success(FactsScreenToastMessages.TMS_HISTORY_DELETE_MESSAGE);
      await handleFetchMarketHitoricalData();
    } catch (err: unknown) {
      const message =
        err && typeof err === 'object' && 'response' in err
          ? (err as { response?: { data?: { error?: string } }; message?: string }).response?.data?.error ??
            (err as { message?: string }).message
          : (err as Error)?.message;
      toast.error(message ?? 'An error occurred');
    } finally {
      const tempDeletingIndexes = [...deletingIndexes];
      const tmepIndexes = new Set<number>([...tempDeletingIndexes]);
      tmepIndexes.delete(marketShareId);
      setDeletingIndexes(tmepIndexes);
    }
  };

  const checkIfCurrentRowIsBeingDelete = (marketShareId: number) => {
    if (deletingIndexes.has(marketShareId)) return true;
  };
  useEffect(() => {
    if (dropdownRef) dropdownRef.current?.focus();
    handleStrategyChange(selectedCOT.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run on selectedCOT change only
  }, [selectedCOT]);

  return {
    isMarketHisotryVisible,
    selectedCOT,
    dropdownRef,
    hiddenInputElementRef,
    cotOptions,
    handleStrategyChange,
    setSelectedCOT,
    toggleMarketHitoryVisibility,
    isMarketHistoryLoading,
    marketStrategyHistoricalData,
    columnDetails,
    handleDeleteFutureTms,
    checkIfCurrentRowIsBeingDelete,
  };
};
